import React, { Component } from "react";
import { Col, Row, Tabs } from "antd";
import echarts from "echarts/lib/echarts";
import $ from 'jquery'
// 引入柱状图（这里放你需要使用的echarts类型 很重要）
import 'echarts/lib/chart/bar';

import 'echarts/lib/chart/line';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';
import { getResouceStaticData } from "../../../../actions";
import './resourceStatic.css'
import { connect } from "react-redux";
import Card from '../../../components/card/Card'
import  * as utils from'../../../../utils/index'
/**
 * 资源统计卡片统计组件
 */
class ResourceStatic extends Component {


    constructor(props) {
        super(props);
        this.state = {
            storyxcolumn: [],
            picturexcolumn: [],
            videoxcolumn: [],
            myChart: null,
            storyCount: 0,
            pictureCount: 0,
            videoCount: 0
        }
        this.resize = this.resize.bind(this);
    }

    componentDidMount() {
        this.screenChange();
        // 基于准备好的dom，初始化echarts实例


        //后台获取资源发布数据信息
        let sotryParam = {
            "type": "month",
            "resourceType": 1
        };
        getResouceStaticData(sotryParam, this.updateResouceStatic.bind(this))

        let pictureParam = {
            "type": "month",
            "resourceType": 2
        };
        getResouceStaticData(pictureParam, this.updateResouceStatic.bind(this))

        let videoParam = {
            "type": "month",
            "resourceType": 3
        };
        getResouceStaticData(videoParam, this.updateResouceStatic.bind(this))
        this.setState({
            myChart: echarts.init(document.getElementById('resourceStatic'))
        })
        setTimeout(() => this.resize(), 1)
    }



    //统计卡片，和统计图的数据是一起过来的
    updateResouceStatic(dayPostCount) {
        if (dayPostCount.resourceType === 1) {
            let data = dayPostCount.data;
            let storyxcolumn = this.getDateFromObject(data);
            this.setState({ storyCount: dayPostCount.data.total, storyxcolumn: storyxcolumn });
        } else if (dayPostCount.resourceType === 2) {
            let data = dayPostCount.data;
            let picturexcolumn = this.getDateFromObject(data);
            this.setState({ pictureCount: dayPostCount.data.total, picturexcolumn: picturexcolumn });
        } else {
            let data = dayPostCount.data;
            let videoxcolumn = this.getDateFromObject(data);
            this.setState({ videoCount: dayPostCount.data.total, videoxcolumn: videoxcolumn });
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        setTimeout(() => this.resize(), 200)
    }

    getDateFromObject(jsonData) {
        let dataArray = [];
        for (let key in jsonData) {
            if (key !== 'total') {
                dataArray.push(jsonData[key]);
            }
        }
        return dataArray;
    }

    screenChange() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        // console.info("componentWillUnmount");
        window.removeEventListener('resize', this.resize);
        this.setState = (state, callback) => {
            return;
        };
    }

    resize() {
        this.state.myChart && this.state.myChart.resize();
    }

    render() {
        let isIE=utils.isIE();

        if (this.state.myChart) {
            if(isIE){
                this.state.myChart.setOption({

                    /*     backgroundColor: '#F5F8FD',*/
                    height: 180,
                    legend: {
                        data: ['稿件', '图片', '视频'],
                        align: 'right',
                        right: 10,
                        padding: [15, 22]
                    },
                    tooltip: {
                        trigger: 'axis',
                        show: true,// 必须引入 tooltip 组件,
                    },
                    color: ['#566eff', '#0d93fd', '#39d3ab'],
                    title: {
                        text: '单位：篇',
                        left: 80,
                        top: 23,
                        textStyle: {
                            fontSize: '12',
                            fontFamily: 'Microsoft YaHei',
                            color: '#9ea5bd'
                        }
                    },
                    xAxis: {
                        // axisTick: {show: false},
                        type: 'category',
                        axisLabel: {
                            textStyle: {
                                fontFamily: 'MicrosoftYaHei',
                                color: '#9ea5bd',
                            },
                        },
                        axisLine: {
                            show: true, //隐藏坐标轴
                            lineStyle: {
                                color: '#f4f6fc',  //坐标轴的颜色
                            },
                        },
                        data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                    },
                    grid: {
                        left: '100',
                        right: '35',
                        bottom: '0',
                        containLabel: true
                    },
                    yAxis: {
                        // axisTick: {show: false},
                        axisLabel: {
                            textStyle: {
                                fontFamily: 'MicrosoftYaHei',
                                color: '#9ea5bd',
                            },
                        },
                        axisLine: {
                            show: true, //隐藏坐标轴
                            lineStyle: {
                                color: '#f4f6fc',  //坐标轴的颜色
                            },
                        },
                        splitLine: {
                            show: true,   // 网格线是否显示
                            //  改变样式
                            lineStyle: {
                                color: '#f4f6fc'   // 修改网格线颜色
                            }
                        },
                    },
                    series: [
                        {
                            type: 'line',
                            name: '稿件',
                            // barWidth: '14px',
                            smooth: true,
                            /*  stack: '总量',*/
                            itemStyle: {
                                normal: {
                                    //  color:'none',
                                    lineStyle: {
                                        color: 'none' //改变折线颜色
                                    }
                                },
                            },
                            areaStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    /* colorStops: [{
                                         offset: 0, color: 'rgba(83,107,255)',// 0% 处的颜色
                                     }, {
                                         offset: 0.82, color: 'rgba(122,143, 255)', opacity: 0.1 // 100% 处的颜色
                                     }, {
                                         offset: 1, color: 'rgba(139,159,255)', opacity: 0.1
                                     }],*/
                                    globalCoord: false // 缺省为 false
                                }
                            },
                            data: this.state.storyxcolumn,
                        },
                        {
                            type: 'line',
                            name: '图片',
                            // barWidth: '14px',
                            smooth: true,
                            /*  stack: '总量',*/
                            itemStyle: {
                                normal: {
                                    // color:'none',
                                    lineStyle: {
                                        color: 'none' //改变折线颜色
                                    }
                                },

                            },
                            areaStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    /* colorStops: [{
                                         offset: 0, color: '#80c8ff' // 0% 处的颜色
                                     }, {
                                         offset: 1, color: '#799aed' // 0% 处的颜色
                                     }],*/
                                    globalCoord: false // 缺省为 false
                                },
                            },
                            data: this.state.picturexcolumn
                        },
                        {
                            type: 'line',
                            smooth: true,
                            /*  stack: '总量',*/
                            itemStyle: {
                                normal: {
                                    //   color:'none',
                                    lineStyle: {
                                        color: 'none' //改变折线颜色
                                    }
                                }
                            },
                            areaStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    /* colorStops: [{
                                         offset: 0, color: '#aaffdb' // 0% 处的颜色
                                     }, {
                                         offset: 1, color: 'rgba(170,255,219,0.8)' // 0% 处的颜色
                                     }],*/
                                    globalCoord: false // 缺省为 false
                                },
                            },
                            name: '视频',
                            // barWidth: '14px',
                            data: this.state.videoxcolumn
                        }
                    ],
                });
            }else{
                this.state.myChart.setOption({

                    /*     backgroundColor: '#F5F8FD',*/
                    height: 180,
                    legend: {
                        data: ['稿件', '图片', '视频'],
                        align: 'right',
                        right: 10,
                        padding: [15, 22]
                    },
                    tooltip: {
                        trigger: 'axis',
                        show: true,// 必须引入 tooltip 组件,
                    },
                    color: ['#566eff', '#0d93fd', '#39d3ab'],
                    title: {
                        text: '单位：篇',
                        left: 80,
                        top: 23,
                        textStyle: {
                            fontSize: '12',
                            fontFamily: 'Microsoft YaHei',
                            color: '#9ea5bd'
                        }
                    },
                    xAxis: {
                        // axisTick: {show: false},
                        type: 'category',
                        axisLabel: {
                            textStyle: {
                                fontFamily: 'MicrosoftYaHei',
                                color: '#9ea5bd',
                            },
                        },
                        axisLine: {
                            show: true, //隐藏坐标轴
                            lineStyle: {
                                color: '#f4f6fc',  //坐标轴的颜色
                            },
                        },
                        data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                    },
                    grid: {
                        left: '100',
                        right: '35',
                        bottom: '0',
                        containLabel: true
                    },
                    yAxis: {
                        // axisTick: {show: false},
                        axisLabel: {
                            textStyle: {
                                fontFamily: 'MicrosoftYaHei',
                                color: '#9ea5bd',
                            },
                        },
                        axisLine: {
                            show: true, //隐藏坐标轴
                            lineStyle: {
                                color: '#f4f6fc',  //坐标轴的颜色
                            },
                        },
                        splitLine: {
                            show: true,   // 网格线是否显示
                            //  改变样式
                            lineStyle: {
                                color: '#f4f6fc'   // 修改网格线颜色
                            }
                        },
                    },
                    series: [
                        {
                            type: 'line',
                            name: '稿件',
                            // barWidth: '14px',
                            smooth: true,
                            /*  stack: '总量',*/
                            itemStyle: {
                                normal: {
                                    //  color:'none',
                                    lineStyle: {
                                        color: 'none' //改变折线颜色
                                    }
                                },
                            },
                            areaStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                     colorStops: [{
                                         offset: 0, color: 'rgba(83,107,255)',// 0% 处的颜色
                                     }, {
                                         offset: 0.82, color: 'rgba(122,143, 255)', opacity: 0.1 // 100% 处的颜色
                                     }, {
                                         offset: 1, color: 'rgba(139,159,255)', opacity: 0.1
                                     }],
                                    globalCoord: false // 缺省为 false
                                }
                            },
                            data: this.state.storyxcolumn,
                        },
                        {
                            type: 'line',
                            name: '图片',
                            // barWidth: '14px',
                            smooth: true,
                            /*  stack: '总量',*/
                            itemStyle: {
                                normal: {
                                    // color:'none',
                                    lineStyle: {
                                        color: 'none' //改变折线颜色
                                    }
                                },

                            },
                            areaStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                     colorStops: [{
                                         offset: 0, color: '#80c8ff' // 0% 处的颜色
                                     }, {
                                         offset: 1, color: '#799aed' // 0% 处的颜色
                                     }],
                                    globalCoord: false // 缺省为 false
                                },
                            },
                            data: this.state.picturexcolumn
                        },
                        {
                            type: 'line',
                            smooth: true,
                            /*  stack: '总量',*/
                            itemStyle: {
                                normal: {
                                    //   color:'none',
                                    lineStyle: {
                                        color: 'none' //改变折线颜色
                                    }
                                }
                            },
                            areaStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                     colorStops: [{
                                         offset: 0, color: '#aaffdb' // 0% 处的颜色
                                     }, {
                                         offset: 1, color: 'rgba(170,255,219,0.8)' // 0% 处的颜色
                                     }],
                                    globalCoord: false // 缺省为 false
                                },
                            },
                            name: '视频',
                            // barWidth: '14px',
                            data: this.state.videoxcolumn
                        }
                    ],
                });
            }

        }

        const { TabPane } = Tabs;

        function callback(key) {
            $(this).css({/*backgroundColor: '#F5F8FD'*/ })
            console.log(key);
        }

        return (
            <Card title="资源统计" style={{ marginTop: 20 }}>
                <div id={"sourceTongji"} style={{ display: 'flex',height:325 }}>
                    <div style={{margin:"auto"}}>
                        <StaticCards number={this.state.storyCount} title='稿件数' img={'images/story.png'} />
                        <StaticCards number={this.state.pictureCount} title='图片数' img={'images/picture.png'} />
                        <StaticCards number={this.state.videoCount} title='视频数' img={'images/video.png'} />
                    </div>
                    <div style={{ width: 'calc( 100% - 110px )', position: 'relative', right: '40px',margin:"auto"}}>
                        <div id="resourceStatic" style={{ height: '255px' }}></div>
                    </div>
                </div>

            </Card>
        )
    }
}

const stateToProps = (state) => {
    return {
        config: state.systemReducer.config,
        navigateStatus: state.systemReducer.navigateStatus
    }
}
export default connect(stateToProps, null)(ResourceStatic);


class HistoryGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            storyxcolumn: [],
            picturexcolumn: [],
            videoxcolumn: [],
            xcloumns: [],
            myChart: null,
            storyCount: 0,
            pictureCount: 0,
            videoCount: 0
        }
        this.resize = this.resize.bind(this);
    }

    componentDidMount() {
        this.screenChange();
        // 基于准备好的dom，初始化echarts实例
        this.setState({
            myChart: echarts.init(document.getElementById('resourceStatichistory'))
        })

        //后台获取资源发布数据信息
        let storyYear = {
            "type": "year",
            "resourceType": 1

        };
        getResouceStaticData(storyYear, this.updateResouceStatic.bind(this))

        let pictureYear = {
            "type": "year",
            "resourceType": 2

        };
        getResouceStaticData(pictureYear, this.updateResouceStatic.bind(this))

        let videoYear = {
            "type": "year",
            "resourceType": 3

        };
        getResouceStaticData(videoYear, this.updateResouceStatic.bind(this))

        //获取资源统计量
        setTimeout(() => this.resize(), 1)
    }


    updateResouceStatic(dayPostCount) {
        if (dayPostCount.resourceType === 1) {
            let data = dayPostCount.data;
            let storyxcolumn = this.getDateFromObjects(data);
            this.setState({ storyxcolumn: storyxcolumn[0], xcloumns: storyxcolumn[1] });
        } else if (dayPostCount.resourceType === 2) {
            let data = dayPostCount.data;
            let picturexcolumn = this.getDateFromObjects(data);
            this.setState({ picturexcolumn: picturexcolumn[0] });
        } else {
            let data = dayPostCount.data;
            let videoxcolumn = this.getDateFromObjects(data);
            this.setState({ videoxcolumn: videoxcolumn[0] });
        }
    }

    getDateFromObjects(jsonData) {
        let yearNumber = [];
        let numbers = [];
        let years = [];

        for (let key in jsonData) {
            if (key !== 'total') {

                numbers.push(jsonData[key]);
                years.push(key);
            }
        }
        yearNumber.push(numbers);
        yearNumber.push(years);
        return yearNumber;
    }

    screenChange() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        // console.info("componentWillUnmount");
        window.removeEventListener('resize', this.resize);
    }

    resize() {
        this.state.myChart.resize();
    }

    render() {
        if (this.state.myChart) {
            this.state.myChart.setOption({

                /* backgroundColor: '#F5F8FD',*/
                height: 180,
                legend: {
                    data: ['稿件', '图片', '视频'],
                    align: 'right',
                    right: 10,
                    padding: [15, 22]
                },
                tooltip: {},
                color: ['#FFBF00', '#00A854', '#0E77D1'],
                title: {
                    text: '单位：篇',
                    left: 80,
                    top: 23,
                    textStyle: {
                        fontSize: '12',
                        fontFamily: 'Microsoft YaHei',
                        color: 'red'
                    }
                },
                xAxis: {
                    axisTick: { show: false },
                    type: 'category',
                    data: this.state.xcloumns
                },
                grid: {
                    left: '100',
                    right: '35',
                    bottom: '10',
                    containLabel: true
                },
                yAxis: {
                    axisTick: { show: false },
                },
                series: [
                    {
                        type: 'bar',
                        name: '稿件',
                        barWidth: '14px',
                        data: this.state.storyxcolumn
                    },
                    {
                        type: 'bar',
                        name: '图片',
                        barWidth: '14px',
                        data: this.state.picturexcolumn
                    },
                    {
                        type: 'bar',
                        name: '视频',
                        barWidth: '14px',
                        data: this.state.videoxcolumn
                    }
                ],
            });
        }
        return (
            <div >
                <div id="resourceStatichistory" style={{ height: '325px' }}></div>
            </div>
        );
    }
}


class StaticCards extends Component {

    render() {

        return (
            <div>
                <div style={{ marginTop: 8 }}>
                    <div style={{ width: 110, height: 76, background: '#f5f8fdff', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {/* <div style={{float:'left',height:76,lineHeight:'76px',marginLeft:20}}>
                            <img  src={this.props.img} alt=""/>
                        </div> */}
                        <span style={{ fontSize: 12, marginRight: 10, color: '#666666', fontFamily: 'MicrosoftYaHei' }}>{this.props.title}</span>
                        <span style={{ fontSize: 20, color: '#333e5f', fontFamily: 'MicrosoftYaHei-Bold', fontWeight: 'bolder' }}>{this.props.number}</span>

                        {/* <div style={{width:50,marginLeft:20,float:'left',marginTop:10}}>
                            <div style={{fontSize:24}}>{this.props.number}</div>
                            <div style={{fontSize:12,}}>{this.props.title}</div>
                        </div> */}
                    </div>
                    {/* <div style={{clear:'both'}}/> */}
                </div>
            </div>

            /* <div >
                 <div  style={{marginTop:20}}>
                     <div style={{width:145,height:55,background:'#f5f8fdff',float:'left'}}>
                         <div style={{width:50,marginLeft:20,float:'left'}}>
                             <div style={{fontSize:20}}>{this.props.number}</div>
                             <div style={{fontSize:12,}}>{this.props.title}</div>
                         </div>
                         <div style={{float:'left',height:50,lineHeight:'50px',marginLeft:20}}>
                             <img style={{}} src={this.props.img} alt=""/>
                         </div>
                     </div>
                     <div style={{clear:'both'}}/>
                 </div>
             </div>*/
        )


        /* <div className='newStaticCards'>
            <Row>
                <Col span={14} xs={14} md={14} xxl={14} className='newStaticCardsNumber'>
                    <span> {this.props.number}</span>
                </Col>
                <Col span={10} xs={10} md={10} xxl={10} className='newStaticCardsNumber'>
                    <div>
                        <img src={this.props.img}/>
                    </div>

                </Col>
            </Row>
            <div className='newStaticCardstitle'>{this.props.title}</div>
        </div>*/
    }

}